<div style="display: flex; flex-direction: column; height: 100svh; overflow: hidden;">

  @if (loading()) {
    <p class="uk-margin-small uk-text-center">Loading...</p>
  }
  @if (error()) {
    <p class="error uk-margin-small uk-text-center">{{ error() }}</p>
  }

  @if (fbService.model()) {

    <!-- Header bar -->
    <header class="fb-header">
      <div class="fb-crumb">
        <button class="uk-button uk-button-default uk-button-small" type="button" (click)="goBack()">
          <span class="material-icons" style="font-size: 16px; vertical-align: middle;">chevron_left</span>Back
        </button>
        <span>Form builder</span>
        <span class="material-icons" style="font-size: 14px;">chevron_right</span>
        <span class="fb-crumb-current">{{ fbService.model()?.name?.trim() || 'Untitled' }}</span>
      </div>
      <div class="uk-flex uk-flex-middle">
<!--        <span class="fb-unsaved"><i>Unsaved changes</i></span>-->
        <a class="uk-button uk-button-default uk-button-small uk-margin-small-right" href="#modal-preview" data-uk-toggle>
          <span class="material-icons" style="font-size: 16px; vertical-align: middle;">visibility</span> Preview
        </a>
        <a class="uk-button uk-button-default uk-button-small uk-margin-small-right" href="#modal-json" data-uk-toggle>Model json</a>
        <button class="uk-button uk-button-primary uk-button-small" type="button" (click)="saveModel()">
          <span class="material-icons" style="font-size: 16px; vertical-align: middle;">check</span> Save
        </button>
      </div>
    </header>

    <!-- Survey meta bar -->
    <div class="fb-meta">
      <span class="fb-meta-icon">
        <span class="material-icons">description</span>
      </span>
      <div style="min-width: 0; flex: 1 1 0;">
        <div class="uk-flex uk-flex-middle" style="gap: 10px;">
          <h2 class="fb-meta-title">{{ fbService.model()?.name?.trim() || 'Untitled' }}</h2>
          <span class="uk-badge"
                [ngStyle]="fbService.model()?.active
                  ? {background: '#1c7a43', color: '#eaf7ee'}
                  : {background: '#8a949a', color: '#f7f9fa'}">
            {{ fbService.model()?.active ? 'Active' : 'Inactive' }}
          </span>
        </div>
        <div class="fb-meta-sub">
          {{ sectionsCount() }} sections · {{ subsectionsCount() }} subsections · {{ fieldsCount() }} fields
          @if (fbService.model()?.submissionStartAt || fbService.model()?.submissionCloseAt) {
            · {{ fbService.model()?.submissionStartAt }} → {{ fbService.model()?.submissionCloseAt }}
          }
        </div>
      </div>
      <button class="uk-button uk-button-default uk-button-small" type="button"
              (click)="showGeneralSettings()">
        <span class="material-icons" style="font-size: 16px; vertical-align: middle;">settings</span> General settings
      </button>
    </div>

    <!-- Section (chapter) tabs -->
    <div class="fb-tabs">
      @for (chapter of fbService.model()?.sections; track chapter.id; let i = $index) {
        <div class="fb-tab" [class.fb-tab--active]="fbService.currentSection()?.id === chapter.id"
             (click)="selectChapter(chapter)">
          <span class="fb-tab-badge">{{ String.fromCharCode(65 + i) }}</span>
          <span>{{ chapter.name?.trim() || 'Untitled chapter' }}</span>
          <span class="fb-tab-count">{{ chapter.subSections?.length ?? 0 }}</span>
          @if (fbService.currentSection()?.id === chapter.id) {
            <span class="material-icons uk-cursor-pointer" style="font-size: 15px; margin-left: 2px; color: var(--fb-faint);"
                  (click)="$event.stopPropagation(); fbService.deleteSection(i)">close</span>
          }
        </div>
      }
      <div class="fb-tab fb-tab-add" (click)="fbService.addSection()">
        <span class="material-icons" style="font-size: 16px;">add</span> Section
      </div>
    </div>

    <!-- Body: subsections sidebar / content / settings panel -->
    <div class="fb-body">

      @if (fbService.currentSection()) {
        <aside class="fb-sub-col">
          <p class="fb-sub-eyebrow">Subsections</p>
          <app-side-menu></app-side-menu>
        </aside>
      }

      <div class="fb-content-col">
        @if (!fbService.currentSection()) {

          <app-main-info></app-main-info>

        } @else {

          @if (!fbService.currentSubsection()) {
            <h5>{{ fbService.currentSection().name?.trim() || 'Untitled Chapter' }}</h5>
            <p [innerHTML]="fbService.currentSection().description" class="uk-text-light"></p>
          }

          @if (fbService.currentSubsection()) {
            <div class="uk-card card-simple uk-padding-small uk-margin-bottom uk-margin-bottom">
              <h6 class="uk-margin-remove-bottom">{{ fbService.currentSubsection().name ?? 'Untitled Section' }}
                <span class="uk-text-muted uk-text-small">{{ fbService.currentSubsection().fields?.length ?? 0 }} fields</span>
              </h6>
              <p [innerHTML]="fbService.currentSubsection().description" class="uk-text-light uk-margin-remove-top"></p>
            </div>

            @for (field of fbService.currentSubsection().fields; track field.id; let i = $index) {
              <div class="uk-margin-bottom">
                <div class="uk-card uk-card-body card-simple uk-padding-small uk-animation-scale-up"
                     [ngClass]="{'highlight-field': fbService.isFieldActive(field)}" (click)="fieldSelection(field)">
                  <div class="uk-card-title uk-flex uk-flex-middle uk-flex-right">
                    <span class="uk-text-bold uk-margin-small-right uk-flex uk-flex-middle">
                      <input id="fieldMandatory-{{field.id}}" class="uk-checkbox" type="checkbox" [(ngModel)]="field.form.mandatory">
                      <label for="fieldMandatory-{{field.id}}" class="uk-checkbox-label uk-margin-small-left">Require this field</label>
                    </span>
                    @if (field.typeInfo.type !== 'radio') {
                      <span class="uk-text-bold uk-margin-small-right uk-flex uk-flex-middle">
                        <input id="multiplicity-{{field.id}}" class="uk-checkbox" type="checkbox" [(ngModel)]="field.typeInfo.multiplicity">
                        <label for="multiplicity-{{field.id}}" class="uk-checkbox-label uk-margin-small-left">Allow multiplicity</label>
                      </span>
                    }
                    <span class="material-icons uk-margin-small-right uk-cursor-pointer" (click)="duplicateField(field)">content_copy</span>
                    <span class="material-icons uk-cursor-pointer" (click)="deleteField(i)">delete</span>
                  </div>
                  <div class="uk-grid uk-grid-column-collapse">
                    <app-field-templates [field]="field" class="uk-width-expand"></app-field-templates>
                    @if (fbService.currentSubsection().fields.length > 1) {
                      <div class="uk-width-auto uk-margin-small-left uk-flex uk-flex-column uk-flex-center">
                        @if (i !== 0) {
                          <div class="uk-margin-small" data-uk-tooltip="Move up">
                            <span class="material-icons uk-cursor-pointer" (click)="move(i, i-1)">north</span>
                          </div>
                        }
                        @if (i !== fbService.currentSubsection().fields.length-1) {
                          <div class="uk-margin-small" data-uk-tooltip="Move down">
                            <span class="material-icons uk-cursor-pointer" (click)="move(i, i+1)">south</span>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
            }

            <div class="uk-width-1-1">
              <div class="uk-card card-simple">
                <div class="uk-border-rounded border-dashed">
                  <a class="uk-flex uk-flex-center uk-flex-middle uk-text-decoration-none uk-padding-small"
                     (click)="fbService.setCurrentField(null); fbService.setSideMenuSettingsType('fieldSelector')">
                    Add field <span class="material-icons">add</span>
                  </a>
                </div>
              </div>
            </div>
          }
        }
      </div>

      <aside class="fb-settings-col">
        <app-settings-side-menu></app-settings-side-menu>
      </aside>
    </div>
  }

</div>

<div #modalJson id="modal-json" class="uk-modal-full" data-uk-modal>
  <div class="uk-modal-dialog">

    <div class="uk-background-secondary uk-padding-small uk-padding-remove-vertical">
      <div class="uk-flex uk-flex-middle uk-flex-between">
        <h2 class="uk-modal-title uk-margin-remove uk-text-white">Model json</h2>
        <div class="uk-margin-small">
          <button class="uk-button uk-button-primary" type="button" (click)="downloadJson()">Download</button>
          <button class="uk-button uk-button-secondary uk-margin-small-left" type="button" (click)="hideModal('modal-json')">Close</button>
        </div>
      </div>
    </div>

    <div class="uk-section-default uk-section uk-section-xsmall">
      <div class="uk-container uk-container-expand ">
        <pre>
          {{ fbService.model() | json }}
        </pre>
      </div>
    </div>

  </div>
</div>


<div #modalPreview id="modal-preview" class="uk-modal-full" data-uk-modal>
  <div class="uk-modal-dialog">

    <div class="uk-background-secondary uk-padding-small uk-padding-remove-vertical">
      <div class="uk-flex uk-flex-middle uk-flex-between">
        <h2 class="uk-modal-title uk-margin-remove uk-text-white">Form preview</h2>
        <div class="uk-margin-small">
          <button class="uk-button uk-button-secondary" type="button" (click)="hideModal('modal-preview')">Close</button>
        </div>
      </div>
    </div>

    <div class="uk-section-default">
      <div>
        @if (showPreview()) {
          <app-survey [model]="fbService.model()" [freeView]="true" [enableWebsocket]="false" [enableCommenting]="false">
            <div class="uk-grid form-top-section">
              <h5 class="uk-width-1-1 uk-margin-bottom">{{ fbService.model()?.name }}</h5>
              <p class="uk-margin-bottom" [innerHTML]="$safeNavigationMigration(fbService.model()?.notice)"></p>
            </div>
            <div class="form-action-bar titleAndActionsBar uk-flex uk-flex-right" style="min-height: 40px"></div>

          </app-survey>
        }
      </div>
    </div>

  </div>
</div>
